import { __spreadArray } from '../../_virtual/_tslib.js';
import { useDebounce } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent, ref, computed, watch } from '@vue/composition-api';
import { callAll, addFlexScrollbarYFix, removeFlexAndFlexScrollbarFix, addFlexScrollbarXFix, addFlexFix } from './utils.js';

var script = defineComponent({
    name: 'SdsTransitionGroup',
    props: {
        name: {
            type: String,
            required: false,
            default: 'fadeMove',
        },
        applyFix: {
            type: String,
            required: false,
            default: 'none',
        },
        applyScrollSnapFixTrigger: {
            type: String,
            required: false,
            default: '',
        },
        tag: {
            type: String,
            required: false,
            default: 'div',
        },
        appear: {
            type: Boolean,
            required: false,
            default: false,
        },
        skipTransition: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [
        'beforeEnter',
        'enter',
        'afterEnter',
        'enterCancelled',
        'beforeLeave',
        'leave',
        'afterLeave',
        'leaveCancelled',
        'beforeMove',
        'afterMove',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var transitionGroupComponentRef = ref(null);
        var transitionGroupRef = computed(function () {
            var _a;
            var transitionGroupElement = (_a = transitionGroupComponentRef.value) === null || _a === void 0 ? void 0 : _a.$el;
            return transitionGroupElement instanceof HTMLElement ? transitionGroupElement : null;
        });
        var removeScrollSnapFixDebounce = useDebounce(function () {
            if (!transitionGroupRef.value) {
                return;
            }
            transitionGroupRef.value.style.scrollSnapType = '';
        }, 300);
        function addAndRemoveScrollSnapFix() {
            if (!transitionGroupRef.value) {
                return;
            }
            transitionGroupRef.value.style.scrollSnapType = 'none';
            removeScrollSnapFixDebounce();
        }
        watch(function () { return props.applyScrollSnapFixTrigger; }, function (newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }
            addAndRemoveScrollSnapFix();
        });
        var JSHooks = computed(function () {
            var fixes = {
                beforeEnter: [],
                enter: [],
                afterEnter: [],
                enterCancelled: [],
                beforeLeave: [],
                leave: [],
                afterLeave: [],
                leaveCancelled: [],
            };
            switch (props.applyFix) {
                case 'flex':
                    fixes.beforeLeave.push(addFlexFix);
                    fixes.afterLeave.push(removeFlexAndFlexScrollbarFix);
                    break;
                case 'flexScrollbarX':
                    fixes.beforeLeave.push(addFlexScrollbarXFix);
                    fixes.afterLeave.push(removeFlexAndFlexScrollbarFix);
                    break;
                case 'flexScrollbarY':
                    fixes.beforeLeave.push(addFlexScrollbarYFix);
                    fixes.afterLeave.push(removeFlexAndFlexScrollbarFix);
                    break;
            }
            return {
                beforeEnter: callAll(__spreadArray(__spreadArray([], fixes.beforeEnter, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['beforeEnter'], args, false));
                    }], false)),
                enter: callAll(__spreadArray(__spreadArray([], fixes.enter, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['enter'], args, false));
                    }], false)),
                afterEnter: callAll(__spreadArray(__spreadArray([], fixes.afterEnter, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['afterEnter'], args, false));
                    }], false)),
                enterCancelled: callAll(__spreadArray(__spreadArray([], fixes.enterCancelled, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['enterCancelled'], args, false));
                    }], false)),
                beforeLeave: callAll(__spreadArray(__spreadArray([], fixes.beforeLeave, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['beforeLeave'], args, false));
                    }], false)),
                leave: callAll(__spreadArray(__spreadArray([], fixes.leave, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['leave'], args, false));
                    }], false)),
                afterLeave: callAll(__spreadArray(__spreadArray([], fixes.afterLeave, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['afterLeave'], args, false));
                    }], false)),
                leaveCancelled: callAll(__spreadArray(__spreadArray([], fixes.leaveCancelled, true), [function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        emit.apply(void 0, __spreadArray(['leaveCancelled'], args, false));
                    }], false)),
            };
        });
        return {
            transitionGroupComponentRef: transitionGroupComponentRef,
            JSHooks: JSHooks,
        };
    },
});

export default script;
